module.exports = "\r\n  <div  id=\"meet\" class=\"meet\"> </div>  \r\n\r\n  <input style=\"visibility: hidden;\" (click)=\"reload()\" id=\"jitsiReload\">\r\n\r\n  <input style=\"visibility: hidden;\" (click)=\"fix()\" id=\"jitsiFix\">\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/prj/liveplanet-app-site/src/app/components/jitsi-component/jitsi.component.html
// module id = ../../../../../src/app/components/jitsi-component/jitsi.component.html
// module chunks = main